var Neatolabs = {
  data: {
    body: null,
    modificationIframe: null,
    viewPort:
      "width=device-width, initial-scale=0.95, maximum-scale=0.95, user-scalable=no, minimal-ui",
    url_for_3DService: "https://3dplugin.lumialase.com",
    url_for_3DService_test: "http://127.0.0.1:3000",
    loginUrl: "https://takeyausa.com/account/login",

    originalViewportMeta: null,

    cart: [],
    product: null,

    buttons: new Set(),
    observedInputs: new Set(),

    user: {},
    collection: {},
    storeName: null,
    storeUrl: window.location.href,
    defined: false,
    sharedSKU: new URLSearchParams(location.search).get("sharedSku")
  },
  observers: {
    // Observing for new elements with the class 'neatolabs_customize_button'
    newButtonObserver: new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (
              //A new .neatolabs_customize_button was added
              (node.classList &&
                node.classList.contains("neatolabs_customize_button")) ||
              //A new .neatolabs_customize_button was added inside an element
              (node.querySelector &&
                node.querySelector(".neatolabs_customize_button"))
            ) {
              Neatolabs.control.defineProductObserver();
            }
          });
        }
      }
    }),

    // Observing for changes in the value of the variant ID input
    variantIdObserver: new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "value"
        ) {
          const lastData = mutation.target.getAttribute(
            "data-neatolabs-last-value"
          );
          if (lastData !== mutation.target.value) {
            mutation.target.setAttribute(
              "data-neatolabs-last-value",
              mutation.target.value
            );

            const uuid = mutation.target.getAttribute("data-neatolabs-uuid");
            Neatolabs.data.collection[uuid].variant_id = Number(
              mutation.target.value
            );
            Neatolabs.control.checkAvailableForCustomization(uuid);
          }
        }
      }
    }),
  },
  setup: () => {
    window.onbeforeunload = function (e) {
      if (document.body.classList.contains("show-customization-modal")) {
        const message =
          "You have unsaved changes! Are you sure you want to leave?";
        e.returnValue = message; // For most browsers
        return message; // For some older browsers
      }
    };

    Neatolabs.data.modificationIframe =
      document.getElementById("neatolabs-app");
    Neatolabs.data.body = document.getElementsByTagName("body")[0];

    // Create an Observer to check for new elements with the class 'neatolabs_customize_button'
    Neatolabs.observers.newButtonObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    Neatolabs.control.defineProductObserver();

    window.removeEventListener("message", Neatolabs.control.iframeMessages.get);
    window.addEventListener("message", Neatolabs.control.iframeMessages.get);

    if (Neatolabs.data.sharedSKU) {
			//console.log("Open modal for shared SKU:", Neatolabs.data.sharedSKU);
			Neatolabs.control.modal.openModalBySku(Neatolabs.data.sharedSKU);
		}
  },
  control: {
    uuid: () => {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    defineProductObserver: () => {
      const buttons = document.querySelectorAll(
        "button[data-role='neatolabsCustomizationButton']"
      );
      //console.log("Buttons:", buttons);
      buttons.forEach((button) => {
        if (button.getAttribute("data-neatolabs-uuid")) return;

        const closestForm = button.closest("form");
        if (closestForm) {
          let variantIdInput = closestForm.querySelector(
            'input[type="hidden"][name="id"]'
          );
          if (!variantIdInput) {
            variantIdInput = closestForm.querySelector(
              'input[type="hidden"][name="neatolabs_alt_id"]'
            );
          }
          const productDetailInput = closestForm.querySelector(
            'input[data-role="neatolabsCollectionData"]'
          );
          const productDetail = productDetailInput
            ? JSON.parse(productDetailInput.value)
            : null;

          if (variantIdInput && productDetail) {
            const productId = productDetail.id;
            const uuid = Neatolabs.control.uuid();
            const hasAvailableVariantToCustomization =
              Neatolabs.control.checkAvailableVariantToCustomization(
                productDetail
              );
            const isCustomizableProduct =
              Neatolabs.control.checkCustomizableProduct(productDetail);

            variantIdInput.setAttribute("data-neatolabs-uuid", uuid);
            button.setAttribute("data-neatolabs-uuid", uuid);
            button.setAttribute(
              "data-neatolabs-has-available-variant-to-customization",
              `${hasAvailableVariantToCustomization}`
            );
            button.setAttribute(
              "data-neatolabs-is-customizable-product",
              `${isCustomizableProduct}`
            );
            button.setAttribute("data-neatolabs-product-id", productId);

            Neatolabs.observers.variantIdObserver.observe(variantIdInput, {
              attributes: true,
              attributeFilter: ["value", "data-neatolabs-uuid"],
            });
            Neatolabs.data.observedInputs.add(variantIdInput);
            Neatolabs.data.collection[uuid] = {
              ...productDetail,
              uuid: uuid,
              variant_id: variantIdInput.value,
            };
            Neatolabs.control.checkAvailableForCustomization(uuid);
          }
        }
        Neatolabs.data.buttons.add(button);
      });
      if (!Neatolabs.data.defined) {
        console.groupCollapsed(
          "%cCustomization Started.",
          "background: #79bc61; color: white; font-size: 14px; padding: 15px 25px 15px 25px; border-radius: 3px;"
        );
        //console.log("Products:", Neatolabs.data.collection);
        console.groupEnd();
        Neatolabs.data.defined = true;
      }
    },
    checkCustomizableProduct: (product) => {
      const hasCustomization =
        product?.["has_customization"] === "true" ||
        product?.["has_customization"] === "false";
      const availableVariantToCustomization =
        Neatolabs.control.checkAvailableVariantToCustomization(product);
      return availableVariantToCustomization || hasCustomization;
    },
    checkAvailableVariantToCustomization: (product) => {
      const variantList = product.variants;
      return variantList.some((variant) => variant.is_enable_customization);
    },
    checkAvailableForCustomization: (uuid) => {
      const product = Neatolabs.data.collection[uuid];

      if (!product) return;

      const variantId = Number(
        product?.["main_variant_id"] || product.variant_id
      );

      
      const variant = product.variants.find((v) => v.id === variantId);

      const available =
        variant?.["is_enable_customization"] &&
        variant?.["available"] &&
        variant?.["inventory_quantity"] > 0;



      const buttons = document.querySelectorAll(
        `button[data-neatolabs-uuid="${uuid}"]`
      );

      buttons.forEach((button) => {
        button.setAttribute("data-neatolabs-variant-id", variantId);
        button.setAttribute("data-neatolabs-available", available);
        button.setAttribute("data-neatolabs-inventory", variant?.["inventory_quantity"]);
        if (available) {
          button.removeAttribute("disabled");
          button.addEventListener("click", Neatolabs.control.clickOnButton);
        } else {
          button.setAttribute("disabled", "disabled");
          button.removeEventListener("click", Neatolabs.control.clickOnButton);
        }
        if (product?.["modification_id"]) {
          Neatolabs.control.form.addModificationDataToForm(uuid, button);
        }
      });
    },
    clickOnButton: (event) => {
      const uuid = event.currentTarget.getAttribute("data-neatolabs-uuid");
      Neatolabs.control.modal.show(uuid);
    },
    user: {
      login: () => {
        const loginPopup = window.open(
          Neatolabs.data.loginUrl,
          "loginPopup",
          `width=600,height=600,top=${(window.innerHeight - 600) / 2},left=${
            (window.innerWidth - 600) / 2
          }`
        );
        const checkPopup = setInterval(() => {
          if (loginPopup.Neatolabs.data.user.id) {
            Neatolabs.data.user = loginPopup.Neatolabs.data.user;
            Neatolabs.control.user.checkUser(false);
            clearInterval(checkPopup);
            loginPopup.close();
          }
          if (loginPopup.closed) {
            clearInterval(checkPopup);
          }
        }, 1000);
      },
      checkUser: (forceToLogin) => {
        if (Neatolabs.data.user.id) {
          Neatolabs.data.modificationIframe.contentWindow.postMessage(
            { user: Neatolabs.data.user },
            "*"
          );
        } else if (forceToLogin) {
          Neatolabs.control.user.login();
        }
      },
    },
    Viewport: {
      change: () => {
        const currentViewportMeta = document.querySelector(
          'meta[name="viewport"]'
        );
        if (currentViewportMeta) {
          // Store the original meta tag
          Neatolabs.data.originalViewportMeta =
            currentViewportMeta.cloneNode(true);
          // Update the content of the current meta tag
          currentViewportMeta.content = Neatolabs.data.viewPort;
        } else {
          // Create and add a new viewport meta tag
          const newViewportMeta = document.createElement("meta");
          newViewportMeta.name = "viewport";
          newViewportMeta.content = Neatolabs.data.viewPort;
          document.head.appendChild(newViewportMeta);
        }
      },
      restore: () => {
        const currentViewportMeta = document.querySelector(
          'meta[name="viewport"]'
        );
        if (currentViewportMeta) {
          currentViewportMeta.remove();
        }
        if (Neatolabs.data.originalViewportMeta) {
          document.head.appendChild(Neatolabs.data.originalViewportMeta);
        }
      },
    },
    page: {
      getQuery: (name) => {
        const url = new URL(window.location.href);
        const queryParams = new URLSearchParams(url.search);
        const query = queryParams.get(name);
        const hasQuery = queryParams.has(name);
        const hash = url.hash;
        const hasHash = hash === name;
        const hashValue = hasHash ? hash.substring(1) : null;

        return {
          value: query || hashValue,
          hasQuery: hasQuery || hasHash,
        };
      },
      removeHash: (name) => {
        const url = new URL(window.location.href);
        if (url.hash === name) {
          history.replaceState(
            null,
            null,
            window.location.pathname + window.location.search
          );
        }
      },
    },
    modal: {
      // ---------------------------------------------------
      // Handle Modal Open/Close
      // ---------------------------------------------------
      getBaseUrl: () => {
        // ---------------------------------------------------
        // Handle Base URL for 3D Service
        // ---------------------------------------------------
        // Use neatolabs query parameter to override the base URL for 3D Service
        // Use Default test:    https://example.com?neatolabs
        // Set url:             https://example.com?neatolabs=https://www.3dPlugin.com
        // ---------------------------------------------------
        const query = Neatolabs.control.page.getQuery("neatolabs");
        if (query.hasQuery) {
          if (query.value) return query.value;
          else return Neatolabs.data.url_for_3DService_test;
        } else {
          return Neatolabs.data.url_for_3DService;
        }
      },
      show: (uuid) => {
        const urlP = new URL(window.location.href);
        const queryParams = new URLSearchParams(urlP.search);

        const product = Neatolabs.data.collection[uuid];
        const id = Number(
          product?.["main_variant_id"] || product?.["variant_id"]
        );
        const storeName = Neatolabs.data.storeName;

        const variant = product?.["variants"]?.find(
          (variant) => variant.id === id
        );

        const sku = variant?.["sku"];

        const shareId = queryParams.get("shareId");
        const url = `sku=${sku}&store_name=${storeName}${
          shareId ? `&shareId=${shareId}` : ""
        }`;

        if (!document.body.classList.contains("show-customization-modal")) {
          history.pushState(
            "",
            document.title,
            window.location.pathname + window.location.search + "#customization"
          );
        }
        const baseUrl = Neatolabs.control.modal.getBaseUrl();

        document.querySelector("#neatolabs-modal-header-title").innerText =
          variant?.title;

        Neatolabs.data.activeUuid = uuid;

        Neatolabs.data.modificationIframe.src = `${baseUrl}?${url}`;
        Neatolabs.data.body.classList.add("show-customization-modal");
        Neatolabs.control.Viewport.change();
      },

      closeModal: () => {
        Neatolabs.data.modificationIframe.src = "";
        Neatolabs.control.page.removeHash("customization");
        if (document.body.classList.contains("show-customization-modal")) {
          history.pushState(
            "",
            document.title,
            window.location.pathname + window.location.search
          );
        }
        Neatolabs.data.body.classList.remove("show-customization-modal");
        Neatolabs.control.Viewport.restore();
      },
      close: () => {
        const userConfirmation = confirm(
          "Are you sure you want to close customization? Any unsaved changes will be lost."
        );
        if (userConfirmation) {
          Neatolabs.control.modal.closeModal();
        }
      },
      openModalBySku: (sku) => {
				const entry = Object.entries(Neatolabs.data.collection).find(([key, item]) =>
					(item?.variants || []).find(v => v?.sku === String(sku))
				);
				const uuid = entry ? entry[0] : null;
				Neatolabs.control.modal.show(uuid);
			}
    },
    form: {
      addModificationDataToForm: (uuid, button) => {
        const product = Neatolabs.data.collection[uuid];
        const variantId = Number(product.variant_id);

        const cartItem = Neatolabs.data.cart.find(
          (item) => item.id === variantId
        );
        if (cartItem && cartItem.properties?.["_eching_sections"]) {
          button.querySelector("span").innerText = "Update Customization";
          const form = button.closest("form");
          Neatolabs.data.collection[uuid].quantity = cartItem.quantity || 1;
          Neatolabs.data.collection[uuid].modification_data =
            cartItem?.properties;

          Neatolabs.control.form.addPropertiesToForm(form, cartItem.properties);
        } else {
          const form = button.closest("form");
          form.querySelectorAll('button[type="submit"]').forEach((submit) => {
            submit.type = "button";
            submit.setAttribute("disabled", "disabled");
          });
          button.remove();
        }
        //TODO: after fix takeya theme, remove this part.
        const form = button.closest("form");
        form.querySelectorAll('[title="Add to Cart"]').forEach((submit) => {
          submit.remove();
        })
      },
      createHiddenInput: (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        return input;
      },
      changeQuantity: (form, quantity) => {
        const getQuantityInput = () => {
          return form.querySelector("input[name='quantity']");
        };
        let quantityInput = getQuantityInput();
        if (!quantityInput) {
          const input = Neatolabs.control.form.createHiddenInput(
            "quantity",
            quantity
          );
          form.appendChild(input);
          quantityInput = getQuantityInput();
        }
        quantityInput.value = quantity;
      },
      addPropertiesToForm(form, properties) {
        const tempInputs = [];

        Object.keys(properties).forEach((key) => {
          const input = Neatolabs.control.form.createHiddenInput(
            `properties[${key}]`,
            properties[key]
          );
          form.appendChild(input);
          tempInputs.push(input);
        });

        return tempInputs;
      },
      removePropertiesFromForm(tempInputs) {
        tempInputs.forEach((input) => input.remove());
      },
    },

    // ---------------------------------------------------
    // Handle Receive Message from iFrame
    // ---------------------------------------------------
    iframeMessages: {
      get: (event) => {
        const receivedDataFromIframe = event.data;
        if (receivedDataFromIframe.hasOwnProperty("close")) {
          Neatolabs.control.modal.close();
        } else if (receivedDataFromIframe.hasOwnProperty("add_to_cart")) {
          Neatolabs.control.cart.add(receivedDataFromIframe);
        } else if (receivedDataFromIframe.hasOwnProperty("product-data")) {
          Neatolabs.data.modificationIframe.contentWindow.postMessage(
            {
              "product-data":
                Neatolabs.data.collection[Neatolabs.data.activeUuid],
              storeUrl: Neatolabs.data.storeUrl,
            },
            "*"
          );
        } else if (
          receivedDataFromIframe.forceToLogin ||
          receivedDataFromIframe.getUser
        ) {
          Neatolabs.control.user.checkUser(receivedDataFromIframe.forceToLogin);
        } else if (receivedDataFromIframe.hasOwnProperty("loadVariant")) {
          const title = receivedDataFromIframe?.["loadVariant"]?.title
          if (title) {
            document.querySelector("#neatolabs-modal-header-title").innerText = title;
          }
          //console.log("loaded variant---->", receivedDataFromIframe["loadVariant"])
        }
      },
    },

    // ---------------------------------------------------
    // Handle Add to Cart
    // ---------------------------------------------------
    cart: NeatolabsTakeyaCart,
  },
};
